module.exports = ".box {\n  width: 80vw;\n  margin-left: 10vw;\n  margin-right: 10vw;\n  margin-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crebo-tool/download/download.component.scss
// module id = ./src/app/crebo-tool/download/download.component.scss
// module chunks = main